module.exports = __webpack_public_path__ + "img/sarabeths.1659e46d.jpg";